define('home/views/ChannelCardPostView',[
    'jquery',
    'underscore',
    'backbone-marionette',
    'core/strings',
    'core/utils/html',

    'home/mixins/withAllstarPopover',
    'home/mixins/withTruncate',
    'home/mixins/withSubviews',
    'home/utils/datetimeUtils',

    'home/templates/channelCardPost',
], function (
    $,
    _,
    Marionette,
    strings,
    html,

    withAllstarPopover,
    withTruncate,
    withSubviews,
    datetimeUtils,

    channelCardPostTemplate
) {
    'use strict';

    var gettext = strings.get;

    var parent = Marionette.ItemView;


    var ChannelCardPostView = parent.extend({
        className: 'post-comments__wrapper',
        template: channelCardPostTemplate,

        templateHelpers: function () {
            var state = this.model.get('state');

            return {
                isHidden: state !== 'visible',
                hiddenExplanation: {
                    flagged: gettext('Pending'),
                    pending: gettext('Pending'),
                    spam: gettext('Detected as spam'),
                    deleted: gettext('Removed'),
                }[state],
                message: this.replaceLinks(this.model.get('message')),
                discussionRoute: this.model.thread.getDiscussionRoute(),
                relativeTime: datetimeUtils.getRelativeDatetime(this.model.get('createdAt')),
                numLines: $(window).width() <= 875 ? 4 : 2,
            };
        },

        /**
         * Replace all anchor tags in the post with their text content, after replacing all text urls with icons.
         *
         * @param {string} message Original message to be decorated with icons
         * @returns {string} Processed HTML
         */
        replaceLinks: function (message) {
            var mediaUrls = _.pluck(this.model.get('media'), 'url');
            var replaceFn = function (link) {
                var iconType = _.contains(mediaUrls, link.href) ? 'images' : 'link';
                // Show an image icon for rich media urls, and an external link icon
                // for all other urls.
                return '<span class="text-smaller icon-' + iconType + '"></span>';
            };
            return html.replaceAnchors(message, replaceFn);
        },
    });

    withAllstarPopover.call(ChannelCardPostView.prototype);
    withTruncate.call(ChannelCardPostView.prototype);
    withSubviews.call(ChannelCardPostView.prototype);

    return ChannelCardPostView;
});

